<template>
  <div class="c-dongle-light">
    <div class="item">
      <label>{{ $t("dongle.switch") }}</label>
      <md-switch class="md-primary" v-model="lightStatus"></md-switch>
    </div>
    <template v-if="lightStatus">
    <div class="item">
      <label>{{ $t("mouse.effect") }}</label>
      <md-field class="field">
        <md-select v-model="lightType" class="select">
          <md-option 
            v-for="effect in effectOptions" 
            :value="effect.value" 
            :key="'dkey' + effect.value"
          >
            {{ $t(`dongle.effects[${effect.i18nIndex}]`) }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <template  v-if="lightType==1">
    <div class="item">
      <label>{{ $t("dongle.hue") }}</label>
      <c-slider class="color-slider" :value="dongleColor" :swatches="[]" @input="onColorInput" />
      <div class="color" :style="{ backgroundColor: dongleColor }"></div>
      <div class="num">
        {{ dongleColor }}
      </div>
    </div>
    <div class="item">
      <label>{{ $t("dongle.saturation") }}</label>
      <a-slider
        class="slider short"
        :value="dongleSaturationPer"
        @change="onSaturationChange"
        :min="1"
        :max="100"
        :tooltipVisible="false"
      />
      <div class="num">{{ dongleSaturationPer }} %</div>
    </div>
    </template>
    <template v-if="lightType == 2 ">
      <div class="item">
        <label>{{ `${$t("dongle.hue")}2` }}</label>
        <c-slider class="color-slider" :value="dongleColor2" :swatches="[]" @input="onColorInput2" />
        <div class="color" :style="{ backgroundColor: dongleColor2 }"></div>
        <div class="num">
          {{ dongleColor2 }}
        </div>
      </div>
      <div class="item">
        <label>{{ `${$t("dongle.saturation")}2` }}</label>
        <a-slider
          class="slider short"
          :value="dongleSaturationPer2"
          @change="onSaturation2Change"
          :min="1"
          :max="100"
          :tooltipVisible="false"
        />
        <div class="num">{{ dongleSaturationPer2 }} %</div>
      </div>
    </template>
    <template v-if="lightType == 7 ">
      <div class="item">
        <label>{{ `${$t("dongle.hue")}3` }}</label>
        <c-slider class="color-slider" :value="dongleColor3" :swatches="[]" @input="onColorInput3" />
        <div class="color" :style="{ backgroundColor: dongleColor3 }"></div>
        <div class="num">
          {{ dongleColor3 }}
        </div>
      </div>
      <div class="item">
        <label>{{ `${$t("dongle.saturation")}3` }}</label>
        <a-slider
          class="slider short"
          :value="dongleSaturationPer3"
          @change="onSaturation3Change"
          :min="1"
          :max="100"
          :tooltipVisible="false"
        />
        <div class="num">{{ dongleSaturationPer3 }} %</div>
      </div>
    </template>
    <div class="item" v-show="lightType !== 1">
      <label>{{ $t("mouse.speed") }}</label>
      <a-slider 
        class="slider" 
        :value="dongleSpeed" 
        @change="onSpeedChange"
        :min="1" 
        :max="20" 
        :tooltipVisible="false" 
      />
      <div class="num">{{ dongleSpeed }}</div>
    </div>
    <div class="item">
      <label>{{ $t("dongle.brightness") }}</label>
      <a-slider 
        class="slider" 
        :value="dongleBrightness" 
        @change="onBrightnessChange"
        :min="1" 
        :max="255" 
        :tooltipVisible="false" 
      />
      <div class="num">{{ dongleBrightness }}</div>
    </div>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CDongleLight",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      timer: 0, // 添加定时器用于防抖
      // 灯效显示顺序: value -> i18n索引
      // 显示顺序: 常亮,呼吸,流光,马赛克,极光,夜之城,光弧
      // value 是传给协议的值，保持不变
      effectOptions: [
        { value: 1, i18nIndex: 0 }, // 常亮
        { value: 2, i18nIndex: 1 }, // 呼吸
        { value: 7, i18nIndex: 6 }, // 流光
        { value: 4, i18nIndex: 3 }, // 马赛克
        { value: 5, i18nIndex: 4 }, // 极光
        { value: 6, i18nIndex: 5 }, // 夜之城
        { value: 3, i18nIndex: 2 }, // 光弧
      ],
    };
  },
  beforeDestroy() {
    // 组件销毁前清理定时器，避免内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
      // 离开页面时如果有未保存的操作，立即保存一次
      this.$store.dispatch("loader/setAM35Dlight", this.getLightData());
    }
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      currentDevice: "currentDevice",
    }),
    ...mapState("mouseAM35", {
      // 从 lightData 对象中获取所有 dongle 灯效相关属性
      dongleLightSwitch: (state) => state.lightData.dongleLightSwitch,
      dongleLightType: (state) => state.lightData.dongleLightType,
      dongleColor: (state) => state.lightData.dongleColor,
      dongleSaturationPer: (state) => state.lightData.dongleSaturationPer,
      dongleColor2: (state) => state.lightData.dongleColor2,
      dongleSaturationPer2: (state) => state.lightData.dongleSaturationPer2,
      dongleColor3: (state) => state.lightData.dongleColor3,
      dongleSaturationPer3: (state) => state.lightData.dongleSaturationPer3,
      dongleSpeed: (state) => state.lightData.dongleSpeed,
      dongleBrightness: (state) => state.lightData.dongleBrightness,
    }),
    // 创建双向绑定计算属性（仅用于 select 和 switch）
    lightType: {
      get() {
        return this.dongleLightType;
      },
      set(value) {
        // 立即更新 store 并保存
        this.saveDongleLightSettings({ dongleLightType: value });
      },
    },
    lightStatus: {
      get() {
        return this.dongleLightSwitch === "1";
      },
      set(value) {
        // 开关状态立即保存，不使用防抖
        this.saveDongleLightSettings({ dongleLightSwitch: value ? "1" : "0" });
      },
    },
  },
  methods: {
    // 获取当前完整的 lightData
    getLightData() {
      return {
        dongleLightSwitch: this.dongleLightSwitch ?? "1",
        dongleLightType: this.dongleLightType || 1, // 灯效模式默认为1（常亮）
        dongleColor: this.dongleColor || "#1400ff",
        dongleSaturationPer: this.dongleSaturationPer ?? 100,
        dongleColor2: this.dongleColor2 || "#1400ff",
        dongleSaturationPer2: this.dongleSaturationPer2 ?? 100,
        dongleColor3: this.dongleColor3 || "#1400ff",
        dongleSaturationPer3: this.dongleSaturationPer3 ?? 100,
        dongleSpeed: this.dongleSpeed ?? 10, // 速度默认为10
        dongleBrightness: this.dongleBrightness ?? 240,
      };
    },
    // 通用滑块变化处理
    handleSliderChange(field, value) {
      window.requestAnimationFrame(() => {
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", {
          ...this.getLightData(),
          [field]: value,
        });
      });
      
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$store.dispatch("loader/setAM35Dlight", this.getLightData());
      }, 500);
    },
    // 滑块事件处理方法
    onSaturationChange(value) {
      this.handleSliderChange('dongleSaturationPer', value);
    },
    onSaturation2Change(value) {
      this.handleSliderChange('dongleSaturationPer2', value);
    },
    onSaturation3Change(value) {
      this.handleSliderChange('dongleSaturationPer3', value);
    },
    onSpeedChange(value) {
      this.handleSliderChange('dongleSpeed', value);
    },
    onBrightnessChange(value) {
      this.handleSliderChange('dongleBrightness', value);
    },
    // 颜色输入处理
    onColorInput(e) {
      window.requestAnimationFrame(() => {
        const color = e.hex ? e.hex : "#" + e.target.value;
        const newColor = color.length === 7 ? color : "#000000";
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", {
          ...this.getLightData(),
          dongleColor: newColor,
        });
        this.debouncedSaveToDevice();
      });
    },
    onColorInput2(e) {
      window.requestAnimationFrame(() => {
        const color = e.hex ? e.hex : "#" + e.target.value;
        const newColor = color.length === 7 ? color : "#000000";
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", {
          ...this.getLightData(),
          dongleColor2: newColor,
        });
        this.debouncedSaveToDevice();
      });
    },
    onColorInput3(e) {
      window.requestAnimationFrame(() => {
        const color = e.hex ? e.hex : "#" + e.target.value;
        const newColor = color.length === 7 ? color : "#000000";
        this.$store.commit("mouseAM35/SET_LIGHT_DATA", {
          ...this.getLightData(),
          dongleColor3: newColor,
        });
        this.debouncedSaveToDevice();
      });
    },
    // 防抖保存到设备
    debouncedSaveToDevice() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.$store.dispatch("loader/setAM35Dlight", this.getLightData());
      }, 500);
    },
    saveDongleLightSettings(changes = {}) {
      console.log(changes, "light changes");

      // 创建 lightData 对象，包含当前值和传入的更改
      const lightData = {
        dongleLightSwitch:
          changes.dongleLightSwitch !== undefined
            ? changes.dongleLightSwitch
            : this.dongleLightSwitch ?? "1",
        dongleLightType:
          changes.dongleLightType !== undefined
            ? changes.dongleLightType
            : this.dongleLightType || 1, // 灯效模式默认为1（常亮）
        dongleColor:
          changes.dongleColor !== undefined ? changes.dongleColor : this.dongleColor || "#1400ff",
        dongleSaturationPer:
          changes.dongleSaturationPer !== undefined
            ? changes.dongleSaturationPer
            : this.dongleSaturationPer ?? 100,
        dongleColor2:
          changes.dongleColor2 !== undefined
            ? changes.dongleColor2
            : this.dongleColor2 || "#1400ff",
        dongleSaturationPer2:
          changes.dongleSaturationPer2 !== undefined
            ? changes.dongleSaturationPer2
            : this.dongleSaturationPer2 ?? 100,
        dongleColor3:
          changes.dongleColor3 !== undefined
            ? changes.dongleColor3
            : this.dongleColor3 || "#1400ff",
        dongleSaturationPer3:
          changes.dongleSaturationPer3 !== undefined
            ? changes.dongleSaturationPer3
            : this.dongleSaturationPer3 ?? 100,
        dongleSpeed:
          changes.dongleSpeed !== undefined ? changes.dongleSpeed : this.dongleSpeed ?? 10, // 速度默认为10
        dongleBrightness:
          changes.dongleBrightness !== undefined
            ? changes.dongleBrightness
            : this.dongleBrightness ?? 240,
      };
      // 调用 store actions 和 mutations 更新数据
      this.$store.dispatch("loader/setAM35Dlight", lightData);
      this.$store.commit("mouseAM35/SET_LIGHT_DATA", lightData);
    },
  },
  watch: {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.c-dongle-light {
  .item {
    @include flex-center;
    height: 0.55rem;
    justify-content: flex-start;

    label {
      width: 120px;
      text-align: left;
    }

    .field {
      width: 320px;
    }

    .slider {
      width: 320px;
      margin-left: 0px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
      }
    }

    .color-slider {
      width: 320px;
      height: 10px;
      margin-right: 10px;
    }

    .color {
      width: 25px;
      height: 25px;
      border: 1px solid $primary-color;
      margin-left: 30px;

      & + .num {
        margin-left: 10px;
      }
    }

    .num {
      width: 80px;
      text-align: left;
      margin-left: 30px;
      white-space: nowrap;
    }
  }

  .button {
    @include button;
    width: 80px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;
    margin: 30px auto 0 auto;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>
<style lang="scss">
.c-dongle-light {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .md-switch.md-theme-default.md-checked.md-primary .md-switch-container {
    background-color: rgb(0, 200, 0);
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}
</style>
